import { useEffect, useState } from "preact/hooks";

export const useIntersectionObserver = (options = {}) => {
    const {
    root = null,
    rootMargin = '0px',
    threshold = 0,
    once = false,
    enabled = true,
    } = options;

    const [node, setNode] = useState(null);
    const [entry, setEntry] = useState(null);

    useEffect(() => {
        if (!enabled || !node) return;

        if (typeof IntersectionObserver === 'undefined') {
            // Fallback: treat as visible if IO isn’t supported (e.g., older browsers/SSR)
            const rect = node.getBoundingClientRect();
            setEntry({
                isIntersecting: true,
                target: node,
                time: (typeof performance !== 'undefined' ? performance.now() : Date.now()),
                rootBounds: null,
                boundingClientRect: rect,
                intersectionRect: rect,
                intersectionRatio: 1,
            });
            return;
        }

        const obs = new IntersectionObserver(([entry]) => {
                setEntry(entry);
                if (entry.isIntersecting && once) obs.disconnect();
            },
            { root, rootMargin, threshold }
        );

        obs.observe(node);
        
        // Clean up
        return () => obs.disconnect();

    }, [node, root, rootMargin, enabled, once, JSON.stringify(threshold)]);

    return [setNode, !!(entry && entry.isIntersecting), entry];
}